module.exports = __webpack_public_path__ + "static/media/newYearSetupSuccess.c492edde.png";